<wcg-dialog [title]="data.title" [description]="data.description">
  <div class="irbContent" content>
    <wcg-switch-new [checked]="irbLabel()" (checkedChange)="handleChange()"
      >IRB+ {{ irbLabel() ? "On" : "Off" }}</wcg-switch-new
    >
    <p class="irbSubTitle">Click the toggle to set priority to IRB+.</p>
  </div>

  <div primary>
    <div class="buttons">
      <button
        mat-flat-button
        mat-button
        wcg-button
        data-testid="cancel-acknowledgement"
        [mat-dialog-close]="false"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        mat-button
        wcg-button
        color="primary"
        [disabled]="data.priority === irbLabel()"
        data-testid="save-acknowledgement"
        (click)="save()"
      >
        Save
      </button>
    </div>
  </div>
</wcg-dialog>
